<template>
  <div>
    <div class="row">
      <div class="col">
        <h5 class="form-header">Productos de la Lista de Precios (Precios Actuales)</h5>
      </div>
      <div class="col">
        <a
          class="btn btn-sm btn-success"
          @click="showModalAddProducto"
        >
          <i class="fa fa-plus"></i>
          Agregar Producto a la Lista de Precio
        </a>
        <a class href="#"></a>
        <a v-if="mostrarRefresh" class="btn btn-sm btn-info" @click="refreshData" href="#">Refresh</a>
      </div>
      <div class="col-sm-4">
        <form action="#" class="form-inline justify-content-sm-end">
          <input
            class="form-control form-control-sm rounded bright"
            placeholder="Search"
            v-on:keyup="keymonitor"
            v-model="searchtext"
            type="text"
          />
          <div class="input-group-append">
            <button class="btn btn-link btn-sm" type="button" @click="filterData">
              <i class="fa fa-search"></i>
            </button>
            <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <select
            class="form-control form-control-sm rounded bright"
            v-model="filterActivo"
            @click="filterData"
          >
            <option value="null">Todos</option>
            <option value="true">Activo</option>
            <option value="false">Inactivo</option>
          </select>
        </form>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-padded">
        <thead>
          <tr>
            <th>Sku</th>
            <th>Nombre del Producto</th>
            <th>Unidad de Medida</th>
            <th class="text-center">Fecha Creacion</th>
            <th class="text-center">Valido Desde</th>
            <th class="text-center">Válido Hasta</th>
            <th class="text-right">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="current in data.results" v-bind:key="current.id" style="cursor: pointer;">
            <td>{{ current.producto.sku }}</td>
            <td>{{ current.producto.nombre }}</td>
            <td>{{ current.unidad_medida.nombre }}</td>
            <td class="text-center">{{ customFormatter(current.habilitado_desde) }}</td>
            <td class="text-center">{{ customFormatter(current.valido_desde) }}</td>
            <td class="text-center">{{ customFormatter(current.valida_hasta) }}</td>
            <td class="text-right bolder nowrap">
              <span class="text-success">Q {{ current.precio}}</span>
            </td>
            <td>
              <router-link
                class="btn btn-sm btn-info"
                :to="{ name: 'cat-lista_precios-editar-precios', params: { id: current.id }}"
              >
                <i class="fa fa-history"></i>
                Historial
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
    <AgregarProductoFormComponent :lista_precio="lista_precio" @cerrandomodal="clearFilterData" />
  </div>
</template>

<script>
import ListaPrecioFormComponent from "@/components/cat/lista_precios/ListaPrecioFormComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import ListaPreciosProductoService from "@/services/catalogos/ListaPreciosProductoService";
import AgregarProductoFormComponent from "@/components/cat/lista_precios/AgregarProductoFormComponent";

export default {
  components: {
    PaginationComponent,
    ListaPrecioFormComponent,
    AgregarProductoFormComponent
  },
  props: ["lista_precio"],
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: null,
      data: [],
      selected: {}
    };
  },
  mounted() {
    let self = this;
    this.refreshData({
      lista_precio: self.lista_precio
    });
  },
  computed: {},
  methods: {
    keymonitor: function(event) {
      let self = this;
      this.refreshData({
        lista_precio: self.lista_precio,
        page: this.currentPage,
        "filter[search]": this.searchtext,
        estatus: this.filterActivo
      });
    },
    onPageChange(page) {
      let self = this;
      self.data = [];
      this.currentPage = page;
      this.refreshData({
        lista_precio: self.lista_precio,
        page: this.currentPage,
        "filter[search]": this.searchtext,
        estatus: this.filterActivo
      });
    },
    filterData() {
      let self = this;
      this.refreshData({
        lista_precio: self.lista_precio,
        page: 1,
        "filter[search]": this.searchtext,
        estatus: this.filterActivo
      });
    },
    clearFilterData() {
      let self = this;
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        lista_precio: self.lista_precio,
        page: 1,
        "filter[search]": this.searchtext,
        estatus: this.filterActivo
      });
    },
    hide: function() {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      ListaPreciosProductoService.fetch(params).then(res => {
        self.data = res.data;
      });
    },
    customFormatter(date) {
      if (date == '' || date == 'None' || date == null){
        return 'No Definida'
      }
      return moment(date).format("DD/MM/YYYY");
    },
    showModalAddProducto() {
      let self = this;
      /*ProveedorService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then(res => {
        self.proveedores = res.data.results;*/
        $("#modalAddProductoPrecio").modal();
      // });
    },
  }
};
</script>
